<template>
  <div class="learning_record">
    <!-- <div class="top_edit FlexjustifyEnd mar_top_20 flex Flexalign cursor_pointer" v-if="!showEdit" @click="changeEdit(true)">
      <el-image class="edit_active_icon" :src="iconPath('edit_active_icon.png')"></el-image>
      <div>编辑</div>
    </div> -->
    <!-- <div class="top_edit FlexjustifyEnd mar_top_20 flex Flexalign">
      <div class="mar_left_10 cursor_pointer" @click="changeEdit(false)">取消</div>
      <div class="mar_left_10 cursor_pointer" @click="deleteRecord('some')">删除</div>
      <div class="mar_left_10 cursor_pointer" @click="deleteRecord('all')">全部清空</div>
    </div> -->
    <div class="record_list mar_top_30" ref="content" v-if="recordList.length" :class="{ expanded: isExpanded }">
      <div class="record_one" v-for="(item, index) in recordList" :key="index">
        <div class="record_top flex Flexalign">
          <div class="record_date">{{ item.date }}</div>
          <div class="real_point mar_left_10"></div>
        </div>
        <div class="record_subList">
          <div
            class="subList_one flex Flexalign"
            v-for="(sitem, sindex) in item.dateList"
            :key="sindex"
          >
            <div class="record_date">{{ sitem.time }}</div>
            <div class="hollow_point"></div>
            <div class="checkbox_box mar_left_10" v-if="showEdit">
              <el-checkbox v-model="sitem.selected" size="large" />
            </div>
            <div class="record_info flex-1 mar_left_15 flex Flexalign FlexBetween">
              <div class="record_info_left flex-1 FlexAround flex flexcolumn">
                <div class="flex info_one">
                  <div class="info_label">章节：</div>
                  <div class="info_value info_value_active toverflow">{{ sitem.chapter }}</div>
                </div>
                <div class="flex info_one">
                  <div class="info_label">观看至：</div>
                  <div class="info_value">{{ sitem.progress }}</div>
                </div>
                <div class="flex info_one">
                  <div class="info_label">课程来源：</div>
                  <div class="info_value toverflow flex-1">{{ sitem.courseResource }}</div>
                </div>
              </div>
              <div class="record_info_right FlexAround Flexalign flex flexcolumn cursor_pointer" @click="playNow({courseId:sitem.courseId,chapterId:sitem.chapterId})">
                <el-image
                  class="play_active_icon"
                  :src="iconPath('play_active_icon.png')"
                ></el-image>
                <div class="">立即观看</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line_active"></div>
    </div>
    <div v-else>
        <moe-empty url="moe_empty_bg_img.png" emptyText="暂无学习记录"></moe-empty>
      </div>
    <div
      class="pagination_box mar_top_10 flex FlexjustifyEnd"
      v-if="isExpanded && listTotal > listQuery.pageSize"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        :total="listTotal"
        @current-change="handleCurrentChange"
      />
    </div>
    <div
      class="more_load flex Flexalign Flexjustify cursor_pointer"
      v-if="showLoadMore"
      @click="toggleExpand"
    >
      {{ isExpanded ? "收起" : "查看更多记录" }}
      <el-icon v-if="!isExpanded">
        <ArrowDown />
      </el-icon>
      <el-icon v-else>
        <ArrowUp />
      </el-icon>
    </div>
    <confirm ref="confirm" :confirmText="confirmText"></confirm>
  </div>
</template>

<script>
import confirm from "@/components/popup/confirm.vue";
export default {
  name: "GjkcH5LearningRecord",
  components: {
    confirm,
  },

  data() {
    return {
      recordList: [
        // {
        //   date: "12.17",
        //   dateList: [
        //     {
        //       time: "10:52",
        //       chapter: "三角函数",
        //       progress: "60%",
        //       courseResource: "高中数学",
        //       link: "",
        //       selected: false,
        //     },
        //     {
        //       time: "10:52",
        //       chapter: "三角函数",
        //       progress: "60%",
        //       courseResource: "高中数学",
        //       link: "",
        //       selected: false,
        //     },
        //     {
        //       time: "10:52",
        //       chapter: "三角函数",
        //       progress: "60%",
        //       courseResource: "高中数学",
        //       link: "",
        //       selected: false,
        //     },
        //   ],
        // },
        // {
        //   date: "12.16",
        //   dateList: [
        //     {
        //       time: "10:52",
        //       chapter: "三角函数",
        //       progress: "60%",
        //       courseResource: "高中数学",
        //       link: "",
        //       selected: false,
        //     },
        //     {
        //       time: "10:52",
        //       chapter: "三角函数",
        //       progress: "60%",
        //       courseResource: "高中数学",
        //       link: "",
        //       selected: false,
        //     },
        //     {
        //       time: "10:52",
        //       chapter: "三角函数",
        //       progress: "60%",
        //       courseResource: "高中数学",
        //       link: "",
        //       selected: false,
        //     },
        //   ],
        // },
      ],
      isExpanded: false,
      showLoadMore: false,
      showEdit: false,
      confirmText: "",
      listQuery: {
        courseId: "",
        chapterId: "",
        studyStatus: "",
        page: 1,
        pageSize: 10,
      },
      listTotal: 0,
    };
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.$nextTick(this.checkOverflow);
      },
    },
  },

  mounted() {
    this.getLearningRecord();
  },

  methods: {
    checkOverflow() {
      if (!this.$refs.content) return;
      this.showLoadMore =
        this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    changeEdit(flag) {
      this.showEdit = flag;
    },
    // 删除
    deleteRecord(type) {
      if (type == "all") {
        this.confirmText = "确定要清除全部学习记录吗？";
      } else {
        this.confirmText = "确定要删除选择的学习记录吗？";
      }
      this.$refs.confirm.confirmShow = true;
    },
    // 获取学习记录
    getLearningRecord() {
      this.$Api.learning
        .getLearningRecord(this.listQuery)
        .then((res) => {
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          let list = res.data.data.list;
          // 1. 按日期分组并转换结构
          const dateMap = {};
          list.forEach((item) => {
            let startDate = new Date(item.startTime);
            // 提取日期（格式：MM.DD）
            const month = String(startDate.getMonth() + 1).padStart(2, "0");
            const day = String(startDate.getDate()).padStart(2, "0");
            const dateKey = `${month}.${day}`;
            // 提取时间（格式：HH:mm）
            const hours = String(startDate.getHours()).padStart(2, "0");
            const minutes = String(startDate.getMinutes()).padStart(2, "0");
            const time = `${hours}:${minutes}`;
            // 计算进度百分比
            const progress = `${Math.round(
              (item.totalSeconds / item.videoDuration) * 100
            )}%`;

            // 构建目标结构项
            const transformedItem = {
              ...item,
              time: time,
              chapter: item.chapterName,
              progress: progress,
              courseResource: item.courseName,
              link: "",
              selected: false,
            };
            // 分组存入map
            if (!dateMap[dateKey]) {
              dateMap[dateKey] = [];
            }
            dateMap[dateKey].push(transformedItem);
          });
          // 2. 转换为数组并按日期倒序排序
          const result = Object.keys(dateMap)
            .map((date) => ({
              date: date,
              dateList: dateMap[date],
            }))
            .sort((a, b) => {
              // 排序逻辑：按日期倒序（最近日期在前）
              const parseDate = (str) => {
                const [month, day] = str.split(".").map(Number);
                return new Date(2025, month - 1, day); // 假设年份为2025
              };
              return parseDate(b.date) - parseDate(a.date);
            });
          this.recordList = result;
          setTimeout(() => {
            this.checkOverflow();
          }, 500);
        })
        .catch(() => {});
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getLearningRecord();
    },
    playNow(info){
      // 后面优化成跳转至章节播放页面
      this.$Jump.href("/onlineLearning", { courseId: info.courseId });
    }
  },
};
</script>

<style lang="scss" scoped>
.learning_record {
  .top_edit {
    font-size: 18px;
    color: #13d6aa;

    .edit_active_icon {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
  }

  .record_list {
    position: relative;
    max-height: 650px;
    overflow: hidden;

    .record_one {
      .record_top {
        .record_date {
          width: 74px;
          height: 28px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 5px;
          color: #fff;
          line-height: 28px;
          text-align: center;
        }

        .real_point {
          width: 7px;
          height: 7px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 50%;
        }
      }

      .record_subList {
        .subList_one {
          margin-top: 5px;
          margin-bottom: 30px;

          .record_date {
            width: 74px;
            height: 28px;
            color: #13d6aa;
            line-height: 28px;
            text-align: right;
          }

          .hollow_point {
            width: 7px;
            height: 7px;
            background: #ffffff;
            border-radius: 50%;
            border: 1px solid #13d6aa;
            box-sizing: border-box;
            margin-left: 10px;
            z-index: 10;
          }

          .record_info {
            // width: 680px;
            height: 90px;
            background: #f5f6f8;
            border-radius: 10px;
            padding: 0 20px;

            .record_info_left {
              line-height: 26px;
              .info_one{
                width: 100%;
              }

              .info_label {
                font-size: 14px;
                color: #999999;
                width: 80px;
              }

              .info_value {
                width: 520px;
                font-size: 14px;
                color: #333333;
              }

              .info_value_active {
                color: #13d6aa;
              }
            }

            .record_info_right {
              line-height: 26px;
              font-size: 14px;
              color: #13d6aa;
              width: 60px;

              .play_active_icon {
                width: 34px;
                height: 34px;
              }
            }
          }
        }
      }
    }

    .line_active {
      height: calc(100% - 59px);
      width: 1px;
      background: #13d6aa;
      position: absolute;
      top: 14px;
      left: 87px;
    }
  }

  .record_list.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 200px;
    height: 35px;
    background: #f5f6f8;
    border-radius: 8px;
    line-height: 35px;
    text-align: center;
    margin: 10px auto;
  }
}
</style>
